import { Button } from "../ui/Button";
import type { LoadFormValues } from "./LoadForm";

const LABELS: Array<[keyof LoadFormValues, string]> = [
  ["originText", "Origin"],
  ["destinationText", "Destination"],
  ["linehaulDollars", "Linehaul $"],
  ["fscPerMileDollars", "FSC $/mi"],
  ["loadedMiles", "Loaded mi"],
  ["deadheadMiles", "Deadhead mi"],
  ["weight", "Weight"],
  ["length", "Length"],
  ["width", "Width"],
  ["height", "Height"],
  ["brokerName", "Broker"],
  ["refNumber", "Ref #"],
];

export function OcrReview({
  fields,
  form,
  onAccept,
  onEdit,
  onCancel,
}: {
  fields: Record<string, unknown>;
  /** The load as it will land on the form; null for non-load reads (fuel price list). */
  form: LoadFormValues | null;
  onAccept: () => void;
  onEdit: () => void;
  onCancel: () => void;
}) {
  const kind = typeof fields["kind"] === "string" ? (fields["kind"] as string) : "";
  const filled = form ? LABELS.filter(([k]) => form[k].trim() !== "") : [];
  const checks = form ? form.note.split("\n").filter((l) => l.startsWith("Check: ")) : [];
  return (
    <div className="card stack" data-testid="ocr-review">
      <strong>{kind ? `Read: ${kind}` : "Check what we read"}</strong>
      {form ? (
        <>
          {filled.length === 0 ? (
            <p className="muted" style={{ margin: 0 }}>Nothing usable was read. Edit to type it in.</p>
          ) : (
            <table className="table">
              <tbody>
                {filled.map(([k, label]) => (
                  <tr key={k}>
                    <th scope="row">{label}</th>
                    <td>{form[k]}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          {checks.length ? (
            <ul className="muted" style={{ margin: 0, paddingLeft: "1.1rem" }}>
              {checks.map((c) => (
                <li key={c}>{c.slice("Check: ".length)}</li>
              ))}
            </ul>
          ) : null}
        </>
      ) : (
        <pre
          style={{
            margin: 0,
            whiteSpace: "pre-wrap",
            fontSize: "0.85rem",
            color: "var(--text-muted)",
          }}
        >
          {JSON.stringify(fields, null, 2)}
        </pre>
      )}
      <div className="row">
        <Button variant="primary" onClick={onAccept}>
          Accept
        </Button>
        <Button onClick={onEdit}>Edit</Button>
        <Button variant="ghost" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </div>
  );
}
